"use client";

import React from "react";
import Link from "next/link";

export default function TechCTA({ techLabel, ctaSection }) {
  const title = ctaSection?.title || null;
  const description = ctaSection?.description || "Connect with our technical strategists today. We offer dedicated consultations tailored precisely to your architecture scales.";
  const btnText = ctaSection?.button?.text || "Schedule Consultation";
  const btnLink = ctaSection?.button?.link || "/contact";

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative z-10">
      <div className="relative rounded-[2.5rem] overflow-hidden bg-[#111010d1] p-10 md:p-16 text-center md:text-left flex flex-col md:flex-row md:items-center md:justify-between gap-8 shadow-2xl shadow-black/50 group">

        {/* Glowing background effects */}
        <div className="absolute top-0 right-0 -mt-20 -mr-20 w-80 h-80 bg-[#f1833b]/20 rounded-full blur-3xl pointer-events-none transition-all duration-700 group-hover:bg-[#f1833b]/30"></div>
        <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-orange-600/10 rounded-full blur-3xl pointer-events-none transition-all duration-700 group-hover:bg-orange-600/20"></div>

        <div className="relative z-10 max-w-2xl space-y-4">
          <span className="text-xs font-bold tracking-widest text-[#f48227] uppercase bg-transparent px-4 py-1.5 rounded-full" style={{ border: "1px solid #f48227" }}>
            Get Started
          </span>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-medium text-white leading-tight">
            {title ? (
              title
            ) : (
              <>
                Ready to build your next <br />
                <span className="text-[#f1833b] font-semibold">{techLabel} innovation?</span>
              </>
            )}
          </h2>
          <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
            {description}
          </p>
        </div>

        <div className="relative z-10 flex-shrink-0 max-sm:w-full">
          <Link
            href={btnLink}
            className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-black bg-[#f1833b] rounded-full hover:bg-[#f1833b]/90 transition-all duration-300 shadow-lg shadow-[#f1833b]/30 hover:shadow-[#f1833b]/50 hover:scale-[1.02] w-full md:w-auto"
          >
            {btnText} 
            <span className="ml-2 font-normal text-base transform group-hover:translate-x-1 transition-transform duration-200">
              {ctaSection?.button?.icon ? (
                <i className={ctaSection.button.icon.includes(' ') ? ctaSection.button.icon : `fa-solid fa-${ctaSection.button.icon}`}></i>
              ) : (
                "↗"
              )}
            </span>
          </Link>
        </div>

      </div>
    </section>
  );
}
